















































































































import Debug from "@/components/utility/Debug.vue";
import LayoutSimple from "@/layouts/LayoutSimple.vue";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { ConfigModule } from "@/store/modules/config";
import { ErrorLogModule } from "@/store/modules/error-log";
import { FeatureModule } from "@/store/modules/feature.store";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: { LayoutSimple, Debug }
})
export default class Setting extends Vue {
  /**
   * The to the action enum.
   */
  public ActionEnum = ActionEnum;

  /**
   * Link to the resource enum.
   */
  public ResourceEnum = ResourceEnum;

  /**
   * List of settings to display as feature flags.
   */
  public settings: ISettingItem[] = [
    {
      title: "views.Setting.interactiveCamera.title",
      subtitle: "views.Setting.interactiveCamera.description",
      get: FeatureModule.isInteractiveCameraEnabled,
      set: FeatureModule.setInteractiveCamera
    },
    {
      title: "views.Setting.pdfUpload.title",
      subtitle: "views.Setting.pdfUpload.description",
      get: FeatureModule.isPdfUploadEnabled,
      set: FeatureModule.setIsPdfUploadEnabled
    },
    {
      title: "views.Setting.query.title",
      subtitle: "views.Setting.query.description",
      get: FeatureModule.isQueryParamsShowing,
      set: FeatureModule.setQueryParamsShowing
    }
  ];

  /**
   * List of thgSettings to display as feature flags.
   */
  public thgSettings: ISettingItem[] = [
    {
      title: "views.Setting.query.title",
      subtitle: "views.Setting.query.description",
      get: FeatureModule.isQueryParamsShowing,
      set: FeatureModule.setQueryParamsShowing
    },
    {
      title: "views.Setting.checkoutCard.title",
      subtitle: "views.Setting.checkoutCard.description",
      get: FeatureModule.isCheckoutCardShowing,
      set: FeatureModule.setIsCheckoutCardShwowing
    }
  ];

  /**
   * List of settings to display as partner settings.
   */
  public partnerSettings: ISettingItem[] = [
    {
      title: "views.Setting.updateProgressStatus.title",
      subtitle: "views.Setting.updateProgressStatus.description",
      get: FeatureModule.isUpdateProgressStatusEnabled,
      set: FeatureModule.setUpdateProgressStatusEnabled
    },
    {
      title: "views.Setting.partnerSetting.title",
      subtitle: "views.Setting.partnerSetting.description",
      get: FeatureModule.isPartnerManagerEnabled,
      set: FeatureModule.setIsPartnerManagerEnabled
    },
    {
      title: "views.Setting.sendToKsr.title",
      subtitle: "views.Setting.sendToKsr.description",
      get: FeatureModule.isSendToKsrEnabled,
      set: FeatureModule.setIsSendToKsrEnabled
    },
    {
      title: "views.Setting.sendToDa.title",
      subtitle: "views.Setting.sendToDa.description",
      get: FeatureModule.isSendToDaEnabled,
      set: FeatureModule.setIsSendToDaEnabled
    },
    {
      title: "views.Setting.sendToPdr.title",
      subtitle: "views.Setting.sendToPdr.description",
      get: FeatureModule.isSendToPdrEnabled,
      set: FeatureModule.setIsSendToPdrEnabled
    }
  ];

  /**
   * List of settings to display in the admin section.
   */
  public adminSettings: ISettingItem[] = [
    {
      title: "views.Setting.admin.debug.title",
      subtitle: "views.Setting.admin.debug.description",
      get: ConfigModule.debug,
      set: ConfigModule.setDebug
    },
    {
      title: "views.Setting.admin.pagination.title",
      subtitle: "views.Setting.admin.pagination.description",
      get: FeatureModule.isPaginationEnabled,
      set: FeatureModule.setPaginationEnabled
    },
    {
      title: "views.Setting.admin.template.title",
      subtitle: "views.Setting.admin.template.description",
      get: FeatureModule.isTemplateEnabled,
      set: FeatureModule.setTemplate
    }
  ];

  /**
   * Get the application version
   */
  get version() {
    return ConfigModule.appVersion;
  }

  /**
   * Checks if the user is authenticated.
   */
  get isAuthenticated() {
    return UserModule.isAuthenticated;
  }

  /**
   * Get the value if the feature settings are shown or not
   */
  get isShowingThgFeatureSettingsList(): boolean {
    return ConfigModule.navigationSettigns.showThgFeatureSettings;
  }

  /**
   * Logs an error in the error log module,
   */
  public generateError() {
    ErrorLogModule.addErrorLog({
      name: "error",
      message: "This is an auto generated error message"
    });
  }
}

/**
 * Setting item interface
 */
interface ISettingItem {
  /**
   * i18n key for the title to be displayed as the header
   */
  title: string;

  /**
   * i18n key for the description of the setting item.
   */
  subtitle: string;

  /**
   * The value of the vuex store setting
   */
  get: boolean;

  /**
   * The set method of the vuex store setting
   */
  set: (value: boolean) => void;

  /**
   * Optional: A link for further details of the setting.
   */
  link?: string;
}
